<template>
  <div no-body class="lku-po">
    <b-row>
      <b-col lg="6">
        <b-input-group>
          <b-input-group-prepend><label>Receiving No.</label></b-input-group-prepend>
              <b-form-input
                v-model="tblData.RecivNo"
                @keyup.13.native="refresh()"
                placeholder="Receiving No." class="ml-1"
              ></b-form-input>
              <b-form-input
                v-model="tblData.nomor"
                @keyup.13.native="refresh()"
                placeholder="Order Number"
              ></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
          <b-form-input v-model="tblData.vendor" @keyup.13.native="refresh()" :disabled="((vendor_id||'') !== '')" placeholder="Vendor/Suplier Name"></b-form-input>
        </b-input-group>
      </b-col>
      <b-col lg="6">
        <b-input-group>
          <b-input-group-prepend><label style="width:100px !important;">Receiving Date</label></b-input-group-prepend>
          <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
          <b-form-input v-model="tblData.tgl2" type="date" class="ml-1"></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend><label style="width:100px !important;">Delivery Order#</label></b-input-group-prepend>
          <b-form-input v-model="tblData.DoNumber" placeholder="Delivery Number"></b-form-input>
          <b-input-group-append>
            <b-button class="btn btn-success ml-3 mr-1" @click="search()" size="sm">
              <i class="fa fa-search"></i> Search
            </b-button>
            <b-button class="btn btn-secondary mr-1" @click="clearFilter()" size="sm">
              <i class="fa fa-eraser"></i>Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-table
      class="mb-0"
      ref="tblAp"
      responsive
      striped
      hover
      small
      style="font-size:smaller;"
      :busy.sync="isBusy"
      :items="data"
      :fields="fields"
      :current-page="tblData.page"
      :per-page="tblData.limit"
      :sort-by.sync="tblData.sortBy"
      :sort-desc.sync="tblData.sortDesc"
      :key="tblData.limit"
      @row-clicked="selectItem"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Loading...</strong>
        </div>
      </template>
        <template v-slot:cell(RecivDate)="data">
          {{ data.item.RecivDate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
        </template>

    </b-table>
    <b-row>
      <b-col cols="4">
        <div class="pt-2">
          Showing {{(tblData.page - 1) * tblData.limit + 1}}
          to
          <span
            v-if="((tblData.page * tblData.limit)>tblData.total)"
          >{{tblData.total}}</span>
          <span v-else>{{tblData.page * tblData.limit}}</span>
          of {{tblData.total}} entries
        </div>
      </b-col>
      <b-col cols="3">
        <b-row class="ml-2 mt-2">
          <span class="pt-1 pr-2">Limit per page</span>
          <b-form-select
            :options="[10, 20, 30, 50, 70, 90, 120]"
            :plain="true"
            v-model="tblData.limit"
            size="sm"
            style="width:80px !important;"
          />
        </b-row>
      </b-col>
      <b-col cols="5">
        <b-pagination
          align="right"
          :total-rows="tblData.total"
          :per-page="tblData.limit"
          v-model="tblData.page"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
.lku-po {
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }  
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>

<script>
import procreceiv from "../../apis/procreceiv";

export default {
  data() {
    return {
      items: [],
      fields: [
          {
            key: "RecivNo",
            label: "Receiving Number",
            thStyle: "width:110px",
            sortable: true
          },
          {
            key: "RecivDate",
            thStyle: "width:90px",
            label: "Receiving Date",
            sortable: true
          },
          {
            key: "orderno",
            label: "P.O Number",
            sortable: true
          },
          {
            key: "orderdate",
            thStyle: "width:90px",
            label: "P.O Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            sortable: true
          },
          {
            key: "requestno",
            label: "Requesition #",
            sortable: true
          },
          {
            key: "remark",
            label: "Description",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        status:'0',
        sortBy: "RecivNo",
        sortDesc: true
      },
      lkuLoading: false,
      isBusy: false
    };
  },
  created: async function() {
      this.tblData.vendor_id=this.vendor_id || '';
      this.tblData.vendor=this.vendor|| '';
      if (this.vendor_id) {
        setTimeout(() => {
          this.refresh();          
        }, 100);
      }  
  },
  props: ["vendor_id", "vendor", "where"],
  methods: {
    selectItem(item, index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
      this.tblData.namaacc = "";
      this.tblData.DoNumber = "";
      this.tblData.nomor = "";
      this.tblData.RecivNo = "";
      this.tblData.tgl1="";
      this.tblData.tgl2="";
      if (!(this.vendor_id))  this.tblData.vendor="";
      this.refresh();
    },
    search: async function() {
      this.tblData.page=1;
      this.$refs.tblAp.refresh();
    },
    refresh: async function() {
      if (this.$refs.tblAp) this.$refs.tblAp.refresh();
    },
    data: async function() {
      this.isBusy = true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      if (this.where) {
        for (const key in this.where) {
          this.tblData[key] = encodeURIComponent(this.where[key]);
        }
      }
      const list = await procreceiv.list(this.tblData);
      // console.log('receiving list: ', list);
      this.isBusy = false;
      return list;
    }
  }
};
</script>
